import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/build/repo/layouts/default.vue").then(m => m.default || m)),
  "digital-screen": defineAsyncComponent(() => import("/opt/build/repo/layouts/digital-screen/DigitalScreen.vue").then(m => m.default || m)),
  "iframe-page": defineAsyncComponent(() => import("/opt/build/repo/layouts/iframe-page.vue").then(m => m.default || m)),
  "password-protected": defineAsyncComponent(() => import("/opt/build/repo/layouts/password-protected/PasswordProtected.vue").then(m => m.default || m))
}